import React from 'react';
import { Grid, Link, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Trans } from 'react-i18next';
import useMedian from '../../hooks/useMedian';
import Image from '../common/Image';

const useStyles = makeStyles()(() => ({
  main: {
    borderRadius: 16,
    background: '#EAEFFF',
    padding: '22px 25px',
    alignItems: 'center',
    overflow: 'hidden',
  },
  new: {
    padding: '0 8px',
    paddingBottom: 4,
    backgroundColor: '#A9DED7',
    borderRadius: 16,
  },
  textContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  image1Container: {
    width: 108,
  },
  image2Container: {
    width: 122,
  },
  image4Container: {
    position: 'absolute',
    right: -16,
    width: 148,
    height: 'auto',
    zIndex: 0,
    '& > div': {
      borderRadius: '0px 65px 65px 0px',
      overflow: 'hidden',
    },
  },
}));

const MobileApps: React.FC = () => {
  const { classes } = useStyles();
  const { isMedian } = useMedian();

  if (isMedian) return;

  return (
    <Grid className={classes.main} container>
      <Grid item xs={12} className={classes.textContainer}>
        <Typography variant="h5" fontWeight="600">
          <Trans i18nKey="headers.mobileApps.title" ns="public">
            Download our <span className={classes.new}>new</span> app!
          </Trans>
        </Typography>
      </Grid>
      <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
        <div className={classes.image1Container}>
          <Link
            // eslint-disable-next-line max-len
            href="https://apps.apple.com/app/apple-store/id6736647530?pt=127356794&ct=Jlive%20Website&mt=8?utm_source=jlivewebsite-header&utm_medium=banner&utm_campaign=ios_launch"
            target="_blank"
            underline="none"
          >
            <Image
              variant="rectangle"
              objectFit="contain"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              className={classes.image}
              src="/static/svg/appsHeader/Download_on_the_App_Store_Badge_US-UK_36.svg"
              alt="/static/svg/appsHeader/Download_on_the_App_Store_Badge_US-UK_36.svg"
            />
          </Link>
        </div>
      </Grid>
      <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
        <div className={classes.image2Container}>
          <Link
            // eslint-disable-next-line max-len
            href="https://play.google.com/store/apps/details?id=co.median.android.erqlzd"
            target="_blank"
            underline="none"
          >
            <Image
              variant="rectangle"
              objectFit="contain"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              className={classes.image}
              src="/static/svg/appsHeader/Google_Play_Store_badge_36.svg"
              alt="/static/svg/appsHeader/Google_Play_Store_badge_36.svg"
            />
          </Link>
        </div>
      </Grid>
      {/* <div className={classes.image4Container}> */}
      {/*  <Image rounded objectFit="contain" src="/static/svg/appsHeader/backimage.svg" alt="backimage" /> */}
      {/* </div> */}
    </Grid>
  );
};

export default MobileApps;
